module.exports = __webpack_public_path__ + "media/backgrounds/diamond-array-gray-d9980c35.png";